// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__fidA4","buttons":"SendReceipts_buttons__1sjz1","email":"SendReceipts_email__1OOsR","bookApptTitle":"SendReceipts_bookApptTitle__Tep-r"};